import React from 'react'
import i18n from 'simple-react-i18n'
import AppStore from 'store/AppStore'
import { Folder, Lock, School, ScienceOutlined, Visibility } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { compact } from 'lodash'
import { darkBlue } from './constants/ColorTheme'

const getExploitationAEP = (settingsProps) => {
    const found = settingsProps.find(s => s.parameter === 'ExploitationAEP')
    if (found) {
        return found.value === 'True' || found.value === 'OUI'
    }
    return false
}

const getLogin = () => {
    return localStorage.getItem('SIEAU_LOGIN')
}

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated use accountUser directly
 */
const getUser = () => {
    return { ...(AppStore.getState().UserReducer.users.find(u => u.login === getLogin()) || {}), ...AppStore.getState().AccountReducer.accountUser }
}

const getGeneralLevelling = () => {
    return { ...(AppStore.getState().AdministrationReducer.applicationSettings.find(u => u.parameter === 'GENERAL_LEVELLING') || {}), ...AppStore.getState().AccountReducer.applicationSettings }?.value
}

const getSetting = (settingList, parameter) => {
    const found = settingList.find(s => s.parameter === parameter)
    return found ? found.value : null
}

const getSettingBool = (settingList, parameter) => {
    const found = settingList.find(s => s.parameter === parameter)
    return found && found.value ? found.value === 'true' : null
}

const getSettingInt = (settingList, parameter) => {
    const found = settingList.find(s => s.parameter === parameter)
    return found && parseInt(found.value) ? parseInt(found.value) : null
}

const getSettingFloat = (settingList, parameter) => {
    const found = settingList.find(s => s.parameter === parameter)
    return found && parseFloat(found.value) ? parseFloat(found.value) : null
}

const getSettingJson = (settingList, parameter) => {
    try {
        const found = settingList.find(s => s.parameter === parameter)
        return found ? JSON.parse(found.value) : null
    } catch (e) {
        return null
    }
}

const getIconsUser = (user, maximumNumberTry) => {
    const showedAdmin = user.isAdmin === '1' || user.admin === '1' ?
        <Tooltip title={i18n.admin}><School sx={{ color: darkBlue, fillOpacity: 1 }} /></Tooltip>
        :
        null
    const showedBlocked = user.consultant === '1' ?
        <Tooltip title={i18n.consultant}><Visibility sx={{ color: darkBlue, fillOpacity: 1 }} /></Tooltip>
        :
        null
    const showedMetadata = user.metadata === '1' ?
        <Tooltip title={i18n.referencialManager}><Folder sx={{ color: darkBlue, fillOpacity: 1 }} /></Tooltip>
        :
        null
    const blockedUser = user.connexionAttempts >= maximumNumberTry ?
        <Tooltip title={i18n.blockedUser}><Lock sx={{ color: darkBlue, fillOpacity: 1 }} /></Tooltip>
        :
        null
    const showedLabo = user.labo === '1' ?
        <Tooltip title={i18n.technicien}><ScienceOutlined sx={{ color: darkBlue, fillOpacity: 1 }} /></Tooltip>
        :
        null
    const showedConsulting = ((!user.isAdmin && !user.admin) || (user.isAdmin === '0' && user.admin === '0')) && (!user.labo || user.labo === '0') && (!user.metadata || user.metadata === '0') ?
        <Tooltip title={i18n.consultant}><Visibility sx={{ color: darkBlue, fillOpacity: 1 }} /></Tooltip>
        :
        null
    return compact([showedAdmin, showedBlocked, showedMetadata, showedLabo, blockedUser, showedConsulting])
}

const getProfileCard = (user, maximumNumberTry) => {
    const showedPicture = user.picture ? (
        <img src={ user.picture } style={{ height: '7rem', width: '7rem', objectFit: 'cover', marginTop: '1.5rem', marginBottom: '27px' }} className='circle responsive-img row'/>)
        : (<i className='material-icons profilePicture row'>account_circle</i>)

    const icons = getIconsUser(user, maximumNumberTry)
    return (
        <div>
            <div className='row no-margin '>
                <div className='col s12 center-align no-padding'>
                    { showedPicture }
                </div>
                <div className='col s12 center-align'>
                    { icons }
                </div>
            </div>
            <div className='row no-margin'>
                <div className='col s12 center-align'>
                    { user.login }
                </div>
            </div>
            <div className='row no-margin'>
                <div className='col s12 center-align large no-padding'>
                    { user.name }
                </div>
            </div>
            <div className='row no-margin'>
                <div className='col s12 center-align large no-padding'>
                    { user.mnemonique }
                </div>
            </div>
            <div className='row'>
                <div className='col s12 center-align'>
                    { user.lastConnexion?.value }
                </div>
            </div>
        </div>
    )
}

const isDeveloppmentEnv = () => {
    return process.env.NODE_ENV !== 'production'
}

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated
 */
const hasHabilitation = (hab, checkAdmin=true) => {
    if (checkAdmin && getUser().isAdmin === '1') {
        return true
    }
    return !!AppStore.getState().AccountReducer.accountHabilitations.find(h => h.habilitation === hab)
}

// fromStationType: 'HYDRO', 'PLUVIO', ou 'PIEZO' ou 'INST' --> le type de station sur lequel vous êtes
// toStationType: 'HYDRO', 'PLUVIO', ou 'PIEZO' ou 'INST' --> le type de station associée que l'on doit afficher (ou pas)
// dataType: le type de donnée complémentaire à afficher ou pas ('all' pour spécifier tous les types de données complémentaires pour ce type de station)
const canShowStationTypeData = (fromStationType, toStationType, dataType = 'all', withRules) => {
    const rules = withRules ? withRules : getSettingJson(AppStore.getState().AdministrationReducer.applicationSettings, 'showDataTypesRules')
    const foundAll = rules?.[fromStationType]?.[toStationType]?.all
    const resultAll = foundAll === undefined ? true : foundAll
    const found = rules?.[fromStationType]?.[toStationType]?.[dataType]
    const resultData = found === undefined ? true : found
    return !!(resultData && resultAll)
}
const isTrue = (value) => {
    return ['True', '1', 'OUI', true, 'true'].includes(value)
}

export {
    getExploitationAEP, getLogin, getUser, getSetting, getSettingInt, getSettingFloat, getSettingBool,
    getSettingJson, getIconsUser, getProfileCard, isDeveloppmentEnv, hasHabilitation, canShowStationTypeData, isTrue, getGeneralLevelling,
}
